import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { AirHandlingUnitData } from "@/services/backend/htz/ahu/types/air-handling-unit-data";

export function LinkedAhuDataCard({ ahu }: { ahu: AirHandlingUnitData }) {
  // Angebote
  // Arbeitsscheine
  // ...

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Verbundene Daten")}</CardTitle>
        <CardDescription>
          {t("Angebote, Arbeitsscheine für Anlage: ")}
          {ahu.designation}
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
